//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Emitter from '@/mixins/emitter';
import Tooltip from '@/mixins/tooltip';
import DpIcon from '../icon/Icon.vue';
import DpSpinnerLoader from '../loader/SpinnerLoader.vue';
import DpIndicator from '../notification/Indicator.vue';

export default {
  name: 'DpButton',
  components: {
    DpSpinnerLoader,
    DpIndicator,
    DpIcon,
  },
  mixins: [Emitter, Tooltip],
  props: {
    /**
     * Used for Vue internal routing
     */
    to: { type: Object, default: () => null },
    /**
     * Link to URL
     */
    href: { type: String, default: null },
    /**
     * Open the link in a new window
     */
    externalLink: { type: Boolean, default: false },
    /**
     * Available types: default | primary | success | warning | error | transparent | delete
     */
    type: { type: String, default: 'default' },
    /**
     * Expand the button to the full width of the container
     */
    fullWidth: { type: Boolean, default: false },
    /**
     * Override the background colour with a CSS-friendly colour
     */
    overrideBackgroundColour: { type: String, default: null },
    /**
     * Override the text colour with a CSS-friendly colour
     */
    overrideTextColour: { type: String, default: null },
    /**
     * Available sizes: default | small | large | tiny
     */
    size: { type: String, default: 'default' },
    /**
     * String name of icon, same used for DpIcon
     */
    icon: { type: String, default: null },
    /**
     * Apply rotation to the icon (in degrees)
     */
    iconRotation: { type: Number, default: null },
    /**
     * Resize the icon separately to the button
     */
    iconSize: { type: String, default: null },
    /**
     * Set the loading state
     */
    loading: { type: Boolean, default: false },
    /**
     * Set the disabled state
     */
    disabled: { type: Boolean, default: false },
    /**
     * Set to true if used as a submit button on a form
     */
    submit: { type: Boolean, default: false },
    /**
     * Hover info used for an indicator. Will show if value is not null
     */
    indicator: { type: String, default: null },
  },
  computed: {
    isWhiteLoader() {
      return this.type === 'success'
        || this.type === 'error'
        || this.type === 'primary'
        || this.type === 'warning';
    },
  },
  methods: {
    handleClick(event) {
      if (this.loading || this.disabled) {
        return;
      }

      this.dispatch('DpSelect', 'handleButtonClick', this);

      /**
       * Click event
       * @event click
       * @property {event} event Passthrough of mouse event
       */
      this.$emit('click', event);

      if (this.to) {
        this.$router.push(this.to).catch(() => {});
        return;
      }
      if (this.href) {
        let url = this.href;
        if (url.substring(0, 3) === '/#/') {
          url = url.substring(2);
        }
        if (!url.startsWith('http') && this.href.charAt(0) !== '/') {
          url = `/${url}`;
        }

        // Open within app, or out?
        if (!this.externalLink) {
          if (url.startsWith('http')) {
            window.location = url;
            return;
          }
          this.$router.push(url).catch(() => {});
        } else {
          window.open(this.href);
        }
      }

      if (this.action) {
        this.action();
      }
    },
  },
};
